

































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgramMedia extends Vue {
  @Prop({ type: Array, default: () => [] }) images!: string[];
  // Player addresses: signed Bunny embeds or YouTube/Vimeo embeds.
  @Prop({ type: Array, default: () => [] }) videos!: string[];
  @Prop({ type: Boolean, default: false }) videoFirst!: boolean;
  @Prop({ type: Boolean, default: false }) cover!: boolean;
  @Prop({ type: Boolean, default: false }) contain!: boolean;

  selected: number = 0;

  get items(): any[] {
    const images = this.images.map((url) => ({ url: url, video: false }));
    const videos = this.videos.map((url) => ({ url: url, video: true }));
    return this.videoFirst ? videos.concat(images) : images.concat(videos);
  }

  get current(): any {
    return this.items[this.selected];
  }

  select(index: number) {
    this.selected = index;
  }
}
